import NewInputField from "../../DesignSystem/Inputs/NewInputField";
import NewMobileNumberInput from "../../DesignSystem/Inputs/NewMobileNumberInput";
import RadioGroup from "../../DesignSystem/Inputs/RadioGroup";
import ReferenceForm from "./ReferenceForm";

const PERMISSION_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const TradeReferenceDetails = ({
  form,
  update,
  validationErrors,
  isReferenceNotRequired = false,
}) => (
  <>
    <NewInputField label="Type of Reference" value="Trade Reference" disabled />
    <div className="grid2 gap-m">
      <NewInputField
        label="Full Name"
        value={form.fullName}
        onChange={(event) => update("fullName", event.target.value)}
        required={!isReferenceNotRequired}
        error={validationErrors.fullName ? "Full Name is required." : ""}
      />
      <NewInputField
        label="Company Name"
        value={form.companyName}
        onChange={(event) => update("companyName", event.target.value)}
        required={!isReferenceNotRequired}
        error={validationErrors.companyName ? "Company Name is required." : ""}
      />
    </div>
    <div className="grid2 gap-m">
      <NewMobileNumberInput
        label="Contact Number"
        value={form.contactNumber}
        onChange={(value) => update("contactNumber", value)}
      />
      <div className="grid2 gap-s">
        <NewInputField
          label="Trading From"
          value={form.tradingFrom}
          onChange={(event) => update("tradingFrom", event.target.value)}
          placeholder="YYYY"
          required={!isReferenceNotRequired}
          error={validationErrors.tradingFrom ? "Trading From is required." : ""}
        />
        <NewInputField
          label="Trading To"
          value={form.tradingTo}
          onChange={(event) => update("tradingTo", event.target.value)}
          placeholder="YYYY"
          required={!isReferenceNotRequired}
          error={validationErrors.tradingTo ? "Trading To is required." : ""}
        />
      </div>
    </div>
    <RadioGroup
      name="tradeAdviserPermission"
      label="Adviser’s permission to contact for reference"
      options={PERMISSION_OPTIONS}
      value={form.adviserPermission}
      onChange={(event) => update("adviserPermission", event.target.value)}
      required={!isReferenceNotRequired}
      inline
      error={validationErrors.adviserPermission}
      deselectable
    />
  </>
);

const TradeReferenceForm = (props) => (
  <ReferenceForm
    {...props}
    referenceKind="trade"
    DetailsFields={TradeReferenceDetails}
  />
);

export default TradeReferenceForm;
